module.exports = __webpack_public_path__ + "static/media/logo-ko-rpi.096f2e5a.png";